// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3Cmum","vLegacy":"SelectSecondary_vLegacy__2AeYY","error":"SelectSecondary_error__1WDHh","disabled":"SelectSecondary_disabled__YE4IB"};